import UserList from '../../../base/pages/userlist';

const userList: UserList = {
  header: 'User list',
  remove: 'Remove'
};

export default userList;
